import React from "react";
import StoreAction from "../constants/store-action";
import UserEvent from "../constants/user-event";
import { getRetailerInformation } from "../utils/retailer";
export default (props) => {
    const handleWantsToDefineTradeInClick = (value) => {
        props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
            value,
            type: "tradeInCar",
            name: "wantsToDefineTradeIn",
        }, () => {
            props.onProceedToNextStep();
        });
    };
    const handleNoTradeInClick = () => {
        props.onIncompleteUserEvent(UserEvent.TRADE_IN_SKIPPED);
        handleWantsToDefineTradeInClick(false);
    };
    const retailerInformation = getRetailerInformation(props.orderOptions);
    const onTradeInClick = () => handleWantsToDefineTradeInClick(true);
    return (React.createElement("div", { className: "page-main" },
        React.createElement("section", { className: "page-section" },
            React.createElement("h1", { className: "h6" }, "Har du inbytesbil?"),
            React.createElement("div", { "data-ecom-content": "" },
                React.createElement("p", null, "Har du en bil du vill byta in n\u00E4r du k\u00F6per din nya bil?"))),
        React.createElement("section", { className: "page-section" },
            React.createElement("div", { "data-ecom-optionlist": "" },
                React.createElement("ul", { className: "option-list" },
                    React.createElement("li", { className: "option-list-item" },
                        React.createElement("button", { className: "option-list-action", onClick: onTradeInClick },
                            React.createElement("div", { className: "option-list-action-title" },
                                "Ja, jag har inbytesbil",
                                React.createElement("i", { className: "icon-arrow-right m-l-half" })))),
                    React.createElement("li", { className: "option-list-item" },
                        React.createElement("button", { className: "option-list-action", onClick: handleNoTradeInClick },
                            React.createElement("div", { className: "option-list-action-title" },
                                "Nej, jag har ingen inbytesbil",
                                React.createElement("i", { className: "icon-arrow-right m-l-half" }))))))),
        React.createElement("section", { className: "page-section" },
            React.createElement("div", { "data-ecom-alert": "" },
                React.createElement("div", { className: "alert-icon-section" },
                    React.createElement("div", { className: "alert-icon" },
                        React.createElement("i", { className: "icon-info no-margin" }))),
                React.createElement("div", { className: "alert-content" },
                    "Notera att best\u00E4llningen g\u00F6rs med",
                    " ",
                    retailerInformation.name,
                    " som avtalspart.")))));
};
